import React from "react";

// Mui
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid2";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SearchIcon from "@mui/icons-material/Search";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LoadingButton from "@mui/lab/LoadingButton";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import FormControl from "@mui/material/FormControl";
import { BarChart } from "@mui/x-charts/BarChart";
import { PieChart } from "@mui/x-charts/PieChart";

import { ButtonSendTheme } from "@/styles/mui/tableListTheme";
// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import Stack from "@mui/material/Stack";

// Fetch
import { getEshopProductSales, getEshopSales } from "@/fetch/fetchStatistics";

// Moment
import getDateRange from "@/lib/getDateRange";
import _ from "lodash";
import moment from "moment";
import "moment/locale/zh-hk";
const ThreeChemBioSalesChartPage = (props) => {
  const { open, setOpen } = props;
  // Theme
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
          },
        },
      },
    },
  });
  // Navigate
  const [isLoading, setLoading] = React.useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [showChart, setShowChart] = React.useState(false);
  const [dateRange, setDateRange] = React.useState("7 days");
  const [expanded, setExpanded] = React.useState(true);
  const [leftAxis, setLeftAxis] = React.useState("DEFAULT_Y_AXIS_KEY");
  const [showRange, setShowRange] = React.useState(false);
  const [filter, setFilter] = React.useState({
    startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const [chartData, setChartData] = React.useState({
    series: [],
    xAxis: [],
    height: 600,
    highlightScope: {
      additionalRadius: 10,
      faded: "global",
    },
  });
  const [pieChartData, setPieChartData] = React.useState([]);

  const dataPickerStartRef = React.useRef(null);
  const dataPickerEndRef = React.useRef(null);
  const fetchSalesData = async () => {
    const { data: sales } = await getEshopSales(
      filter.startDate,
      filter.endDate
    );

    let xAxis = [
      {
        data: [],
        scaleType: "band",
        id: "axis1",
        valueFormatter: (value, context) =>
          `${moment(value).format(`DD/MM`)}\n${moment(value).format(`dddd`)}`,
      },
    ];
    const completeSeriesData = {
      id: "complete-sales-amount",
      data: [],
      label: `已完成訂單(HKD)`,
      highlightScope: {
        highlighted: "item",
      },
      stack: "total",
      valueFormatter: (value) => `$${new Intl.NumberFormat().format(value)}`,
    };

    const inprogSeriesData = {
      id: "inprog-sales-amount",
      data: [],
      label: `處理中訂單(HKD)`,
      highlightScope: {
        highlighted: "item",
      },
      stack: "total",
      valueFormatter: (value) => `$${new Intl.NumberFormat().format(value)}`,
    };

    const series = [];
    let labels = getDateRange(filter.startDate, filter.endDate);
    xAxis[0].data = labels;
    _.forEach(labels, (label) => {
      const foundInprogSales = sales.find(
        (sale) =>
          sale.tx_date === moment(label).format("YYYY-MM-DD") &&
          sale.order_status === "INPROG"
      );
      const foundCompleteSales = sales.find(
        (sale) =>
          sale.tx_date === moment(label).format("YYYY-MM-DD") &&
          sale.order_status === "COMPLETED"
      );
      if (foundInprogSales === undefined || !foundInprogSales.total) {
        inprogSeriesData.data.push(0);
      } else {
        inprogSeriesData.data.push(parseFloat(foundInprogSales.total));
      }
      if (foundCompleteSales === undefined || !foundCompleteSales.total) {
        completeSeriesData.data.push(0);
      } else {
        completeSeriesData.data.push(parseFloat(foundCompleteSales.total));
      }
    });
    series.push(completeSeriesData);
    series.push(inprogSeriesData);
    setLeftAxis("DEFAULT_Y_AXIS_KEY");
    setChartData({
      series,
      xAxis,
      height: 500,
    });
    setShowChart(true);
  };
  const onClose = () => {
    setDialogOpen(false);
  };
  const handleAxisClick = async (e, d) => {
    const { data: sales } = await getEshopProductSales(d.axisValue);
    setPieChartData([
      {
        data: sales,
      },
    ]);
    setDialogOpen(true);
  };
  const handDateRangeChange = (e) => {
    switch (e.target.value) {
      case "custom":
        setShowRange(true);
        setFilter((prev) => {
          return {
            ...prev,
            dateRange: e.target.value,
          };
        });
        setTimeout(() => {
          dataPickerStartRef.current.parentElement.click();
        }, 100);

        break;
      case "7 days":
        setShowRange(false);
        setFilter((prev) => {
          return {
            ...prev,
            startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            dateRange: "custom",
          };
        });
        break;
      case "30 days":
        setShowRange(false);
        setFilter((prev) => {
          return {
            ...prev,
            startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            dateRange: "custom",
          };
        });
        break;
      case "6 months":
        setShowRange(false);
        setFilter((prev) => {
          return {
            ...prev,
            startDate: moment().subtract(6, "months").format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            dateRange: "custom",
          };
        });
        break;
      case "1 years":
        setShowRange(false);
        setFilter((prev) => {
          return {
            ...prev,
            startDate: moment().subtract(1, "years").format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            dateRange: "custom",
          };
        });
        break;
      default:
        break;
    }
    setDateRange(e.target.value);
  };
  React.useEffect(() => {
    fetchSalesData();
  }, []);
  return (
    <Layout
      header="DailyPage"
      selectedIndex={34}
      open={open}
      setOpen={setOpen}
      key="1"
    >
      <Title title="銷售統計(3ChemBio)" />
      <ThemeProvider theme={theme}>
        <Accordion
          expanded={expanded}
          style={{ flexGrow: 1, display: "block" }}
        >
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => setExpanded(!expanded)}
              ></ExpandMoreIcon>
            }
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SearchIcon></SearchIcon>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid
                size={{
                  xs: 12,
                  md: 3,
                  lg: 3
                }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">時間</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={dateRange}
                    label="date"
                    onChange={handDateRangeChange}
                  >
                    <MenuItem value={"7 days"}>最近7天</MenuItem>
                    <MenuItem value={"30 days"}>最近30天</MenuItem>
                    <MenuItem value={"6 months"}>最近半年</MenuItem>
                    <MenuItem value={"1 years"}>最近1年</MenuItem>
                    <MenuItem value={"custom"}>自訂</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {showRange && (
                <>
                  <Grid
                    size={{
                      xs: 12,
                      md: 3,
                      lg: 3
                    }}>
                    <DatePicker
                      disableFuture
                      maxDate={filter.endDate}
                      label="開始"
                      value={filter.startDate}
                      components={{
                        OpenPickerIcon: () => (
                          <CalendarMonthIcon ref={dataPickerStartRef} />
                        ),
                      }}
                      onChange={(newValue) => {
                        setFilter((prev) => {
                          return {
                            ...prev,
                            startDate: moment(newValue).format("YYYY-MM-DD"),
                            endDate: moment(newValue)
                              .endOf("months")
                              .format("YYYY-MM-DD"),
                          };
                        });
                        dataPickerEndRef.current.parentElement.click();
                      }}
                      renderInput={(params) => (
                        <TextField {...params} sx={{ width: "100%" }} />
                      )}
                    />
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      md: 3,
                      lg: 3
                    }}>
                    <DatePicker
                      disableFuture
                      minDate={filter.startDate}
                      label="結束"
                      value={filter.endDate}
                      components={{
                        OpenPickerIcon: () => (
                          <CalendarMonthIcon ref={dataPickerEndRef} />
                        ),
                      }}
                      onChange={(newValue) => {
                        setFilter((prev) => {
                          return {
                            ...prev,
                            endDate: moment(newValue).format("YYYY-MM-DD"),
                          };
                        });
                      }}
                      renderInput={(params) => (
                        <TextField {...params} sx={{ width: "100%" }} />
                      )}
                    />
                  </Grid>
                </>
              )}

              <Grid
                size={{
                  xs: 12,
                  md: 1,
                  lg: 1
                }}>
                <ThemeProvider theme={ButtonSendTheme}>
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <LoadingButton
                      size="small"
                      onClick={async () => {
                        setLoading(true);
                        await fetchSalesData();
                        setLoading(false);
                      }}
                      endIcon={<SearchOutlinedIcon fontSize="small" />}
                      loading={isLoading}
                      loadingPosition="end"
                      variant="contained"
                    >
                      搜尋
                    </LoadingButton>
                  </div>
                </ThemeProvider>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>
      {showChart && (
        <Fade in={true} mountOnEnter unmountOnExit>
          <StyledPaper page={"yes"}>
            <ThemeProvider theme={TableListTheme}></ThemeProvider>
            <Stack
              direction={{ xs: "column", md: "row" }}
              textAlign="center"
              sx={{ width: "100%" }}
            >
              <Box
                sx={{ flexGrow: 1, mt: 1 }}
                justifyContent="center"
                alignItems="center"
                display="flex"
              >
                <BarChart
                  onAxisClick={handleAxisClick}
                  leftAxis={leftAxis}
                  margin={{ right: 5, left: 70 }}
                  series={chartData.series}
                  xAxis={[{ ...chartData.xAxis[0] }]}
                  height={chartData.height}
                />
              </Box>
            </Stack>
          </StyledPaper>
        </Fade>
      )}
      <Dialog open={dialogOpen} maxWidth="lg" onClose={onClose} fullWidth>
        <DialogContent>
          <PieChart
            margin={{ right: 5 }}
            slotProps={{
              legend: {
                direction: "row",
                position: { vertical: "bottom", horizontal: "middle" },
                padding: 0,
              },
            }}
            series={pieChartData}
            height={400}
          />
        </DialogContent>
      </Dialog>
    </Layout>
  );
};

export default ThreeChemBioSalesChartPage;
